import { css } from '@emotion/css';

import { HeaderLargeBlock } from '../../../layout/components/header/HeaderLargeBlock.tsx';
import { useLanguage } from 'dg-web-shared/lib/Localization.tsx';
import { portalSlideIn } from '../../../account/root/components/PortalSlidein.tsx';

export const FAQSlideIn = portalSlideIn(FAQPage);

export function FAQPage() {
    {
        const { language } = useLanguage();
        return (
            <>
                <HeaderLargeBlock />
                <div
                    className={css({
                        display: 'flex',
                        flex: 1,
                        width: '100%',
                        height: '100%',
                        minHeight: 0,
                    })}
                >
                    <iframe
                        src={`https://parkingpay.freshdesk.com/${language}/support/solutions/folders/204000127605`}
                        loading="lazy"
                        referrerPolicy="no-referrer"
                        className={css({
                            flex: 1,
                            width: '100%',
                            height: '100%',
                            border: 'none',
                        })}
                    ></iframe>
                </div>
            </>
        );
    }
}
